import React from 'react';
import PropTypes from 'prop-types';
import VideoContainer from './styles';

const SingleVideo = ({ src, autoPlay }) => (
	<VideoContainer
		preload="true"
		autoPlay={autoPlay}
		loop="loop"
		webkit-playsinline="true"
		playsinline="true"
		controls
		key={src}
	>
		<source src={src} type="video/mp4" id="videoA" />
	</VideoContainer>
);

export default SingleVideo;

SingleVideo.defaultProps = {
	autoPlay: 'autoplay'
};

SingleVideo.propTypes = {
	src: PropTypes.string.isRequired,
	autoPlay: PropTypes.string.isRequired
};
